import Highlight from 'components/Highlight';
import './AcrisLinks.css';

const EMPTY_VALUE_PLACEHOLDER = '—';
const MAX_VISIBLE_PARTIES = 3;

/**
 * Renders ACRIS grantor / grantee parties as name plus city, state.
 */
function AcrisParty(props) {
	const { text, searchString } = props;
	const parties = Array.isArray(text) ? text : [];

	if (parties.length === 0) {
		return <span className="acris-party-empty">{EMPTY_VALUE_PLACEHOLDER}</span>;
	}

	const visible = parties.slice(0, MAX_VISIBLE_PARTIES);
	const extraCount = parties.length - visible.length;

	return (
		<div className="acris-party">
			{visible.map((party, index) => {
				const name = party?.name || '';
				const location = [party?.city, party?.state].filter(Boolean).join(', ');
				const display = location ? `${name} ${location}` : name;

				return (
					<div key={`${name}-${index}`} className="acris-party-row">
						<Highlight text={display} substring={searchString} />
					</div>
				);
			})}
			{extraCount > 0 ? (
				<div className="acris-party-more">+{extraCount} more</div>
			) : null}
		</div>
	);
}

export default AcrisParty;
